import { ref } from "vue";
import ChatService from "../../../core/core/chat/ChatService";
import AiSubectData from "./ai/AiSubectData";
import MindMe from "../../facade/MindMe";
import Config from "../../../core/core/calcule/Config";
import Util from "../../../utils/Util";

class MessageChat {
    constructor(isElectron = true) {
        this.chatService = new ChatService(isElectron, 'https://todo.mindyushu.com');
        this.loading = false;
        this.messages = ref([]);
        this.inputMessage = ref('');
        this.messagesContainer = ref(null);
        this.isStreaming = ref(false);
        this.isElectron = isElectron;
        this.deleagte;
        this.nodeId = -1;

        this.firstLevelSeparatedBy = "|";
        this.secondLevelSeparatedBy = "--";

        this.isTestData = false;
        this.valueIndex = 0;
    }

    sendChatMessageToAiForMap() {

    }

    testData() {
//        let value = "--1 阅读--2 运动健身--3 音乐欣赏--4 绘画创作--5 烹饪烘焙--6 旅行探索--7 摄影记录--8 手工艺制作--9 电影观赏--10 游戏娱乐"
        let value = "1春节:拜年送红包--1 阅读--2 运动健身--3 音乐欣赏--4 绘画创作--5 烹饪烘焙--6 旅行探索--7 摄影记录--8 手工艺制作--9 " +
                "电影观赏--10 游戏娱乐|2元宵节:赏灯吃元宵--1 阅读--2 运动健身--3 音乐欣赏--4 绘画创作--5 烹饪烘焙--6 旅行探索--7 摄影记录--8 " +
                "手工艺制作--9 电影观赏--10 游戏娱乐|3清明节:扫墓祭祖|4端午节:赛龙舟吃粽子|5中秋节:赏月吃月饼|6重阳节:登高敬老|7国庆节:升旗仪式|8圣诞节:" +
                "互赠礼物|9母亲节:送花表感恩|10父亲节:家庭聚餐|11情人节:赠送巧克力|12元旦:发送祝福短信|";
        this.valueIndex += 5;
        if (this.valueIndex >= value.length) {
            this.valueIndex = value.length;
        }
        let isCompleted = this.valueIndex >= value.length;
        this.messageConvertToMap(value, true);
        // if (valueIndex < value.length()) {
        //     UiHandlers.postDelayed(new Runnable() {
        //         @Override
        //         public void run() {
        //             testData();
        //         }
        //     }, 300);
        // } else {
        //     System.out.println("TestData-> Completed");
        // }
    }

    messageConvertToMap(message, isCompleted) {
        let lines = message.split("" + this.firstLevelSeparatedBy);
        var stack = [];
        var id = -1;
        for (let index = 0; index < lines.length; index++) {
            let line = lines[index]
            if (line.trim().length == 0) {
                continue; // 跳过空行
            }
            // 创建新的主题对象
            if (line.includes(this.secondLevelSeparatedBy)) {
                let sonSubs = line.split(this.secondLevelSeparatedBy);
                if (sonSubs.length == 0) {
                    continue;
                } else if (sonSubs.length == 1) {
                    id += 1;
                    stack.push(new AiSubectData(id, sonSubs[0].trim(), []));
                } else {
                    id += 1;
                    stack.push(new AiSubectData(id, sonSubs[0].trim(), []));
                    for (let i = 1; i < sonSubs.length; i++) {
                        let sonLine = sonSubs[i];
                        if (sonLine.trim().length == 0) {
                            continue; // 跳过空行
                        }
                        id += 1;
                        stack[stack.length - 1].addSubject(new AiSubectData(id, sonLine.trim(), []));
                    }
                }
            } else {
                id += 1;
                stack.push(new AiSubectData(id, line.trim(), []));
            }

        }
        this.deleagte.onChatMessages(stack, this.nodeId, isCompleted);
    }

    sendChatMessageToAiForMap(mainValue, parentValue, targetValue, aiChatMessage,
                                          isFreeNode, nodeId) {
        this.nodeId = nodeId;
        let chatMessage = "";
        if (aiChatMessage != null && aiChatMessage.length > 0) {
            chatMessage = aiChatMessage;
        } else if (mainValue == parentValue && parentValue == targetValue) { //中心主题生成下一级内容
            chatMessage = "我在编辑中心主题为「" + mainValue + "」的思维导图，请帮我扩展（两级）下一级主题和主题的下一级子主题（内容对应的语言如中文->给我中文，英文->给我英文）内容，生成合适的主题内容，主题数量根据语意给我，" +
                    "每条主题控制在（汉字12个字、其他语言24）以内" + "，每条子主题控制在（汉字20个字、其他语言30）以内，" +
                    "主题之间用" + this.firstLevelSeparatedBy + "分割，" + "子主题之间用" + this.secondLevelSeparatedBy + "分割，" +
                    "分割比如：A" + this.secondLevelSeparatedBy + "a1" + this.secondLevelSeparatedBy + "a2" + this.secondLevelSeparatedBy + "a3" + this.firstLevelSeparatedBy +
                    "B" + this.secondLevelSeparatedBy + "b1" + this.secondLevelSeparatedBy + "b2" + this.secondLevelSeparatedBy + "b3" + this.firstLevelSeparatedBy +
                    "C" + this.secondLevelSeparatedBy + "c1" + this.secondLevelSeparatedBy + "c2" + this.secondLevelSeparatedBy + "c3" + this.firstLevelSeparatedBy +
                    "，只给我必要内容，解释说明类文字不需要，方便后续代码分割处理和使用";

        } else if (mainValue == parentValue && parentValue != targetValue) { //上级是中心主题，生成当前下一级内容
            chatMessage = "我在编辑「" + mainValue + "」思维导图，当前正在编辑主题「" + targetValue + "」位于中心主题子级，请帮我扩展下一级子主题内容（内容对应的语言如中文->给我中文，英文->给我英文）内容，生成合适的子主题内容，子主题数量根据语意给我，" +
                    "每条子主题控制在（汉字20个字、其他语言30）以内，" +
                    "子主题之间用" + this.firstLevelSeparatedBy + "分割，" +
                    "分割比如：A" + this.firstLevelSeparatedBy + "B" + this.firstLevelSeparatedBy + "C" +
                    "，只给我必要内容，解释说明类文字不需要，方便后续代码分割处理和使用";
        } else { //根据中心主题、父级，生成当前下一级内容
            chatMessage = "我在编辑「" + mainValue + "」思维导图，当前正在编辑「" + targetValue + "」子主题，它的上一级是「" + parentValue + "」 请帮我扩展「" + targetValue + "」下一级子主题内容（内容对应的语言如中文->给我中文，英文->给我英文）内容，生成合适的子主题内容，子主题数量根据语意给我，" +
                    "每条子主题控制在（汉字20个字、其他语言30）以内，" +
                    "子主题之间用" + this.firstLevelSeparatedBy + "分割，" +
                    "分割比如：A" + this.firstLevelSeparatedBy + "B" + this.firstLevelSeparatedBy + "C" +
                    "，只给我必要内容，解释说明类文字不需要，方便后续代码分割处理和使用";
        }


        if (this.isTestData) {
            MindMe.useAiAddTimes()
            Config.lastUseAITime = Util.getCurrentTime()
            this.testData();
            return;
        }
        this.sendMessage(chatMessage, "deepseek-v3.1");
    }

    sendMessage(message, model) {
        if (!message || this.loading) {
            return;
        }
        // 添加用户消息
        this.messages.value.push({
            role: 'user',
            content: message,
            timestamp: new Date(),
        });
        
        // 添加AI消息占位
        this.messages.value.push({
            role: 'assistant',
            content: '',
            timestamp: new Date(),
        });
        
        this.loading = true;
        this.isStreaming.value = true;
        MindMe.useAiAddTimes()
        Config.lastUseAITime = Util.getCurrentTime()
        try {
            this.chatService.sendMessage({
                message,
                model: model,
                userId: "",
            },
            // 数据块回调
            (chunk) => {
                const lastIndex = this.messages.value.length - 1;
                this.messages.value[lastIndex].content += chunk;
                this.messageConvertToMap(this.messages.value[lastIndex].content, false)
                // console.log('data chunk->', chunk);
                // console.log('data content->', this.messages.value[lastIndex].content);
            },
            // 完成回调
            () => {
                const lastIndex = this.messages.value.length - 1;
                this.messageConvertToMap(this.messages.value[lastIndex].content, true)
                // console.log('completed content->', this.messages.value);
                // console.log('Stream completed');
            },
            // 错误回调
            (error) => {
                // console.error('Stream error:', error);
                const lastIndex = this.messages.value.length - 1;
                this.messages.value[lastIndex].content += `\n[错误: ${error.message}]`;
            }
            );
        } catch (error) {
            // console.error('Request error:', error);
            if (error.name !== 'AbortError') {
            const lastIndex = this.messages.value.length - 1;
            this.messages.value[lastIndex].content = '请求失败，请重试。';
            }
        } finally {
            this.loading = false;
            this.isStreaming.value = false;
        }
  
    }
}

export default MessageChat